export const listOfArchive = {
  fromArchiveList: 'fromArchiveList',
  toArchiveList: 'toArchiveList',
}
